import { observer } from 'mobx-react';

import { useCountdownTimer, useWidgetAdaptiveText } from '../../../hooks';

import styles from './TournamentWidgetTimer.module.scss';

interface TournamentWidgetTimerProps {
  endDate: string;
  startDate: string;
  onEnd: () => void;
  to: 'start' | 'end';
  extended?: boolean;
  noPosition?: boolean;
}

const getContainerStyle = (extended?: boolean, noPosition?: boolean) => {
  if (extended) {
    return styles.containerExtended;
  }
  return noPosition ? styles.noPositionContainer : styles.container;
};

const getTextStyle = (extended?: boolean, noPosition?: boolean) => {
  if (extended) {
    return styles.textExtended;
  }
  return noPosition ? styles.noPositionText : styles.text;
};

function TournamentWidgetTimerComponent(props: TournamentWidgetTimerProps) {
  const { startDate, endDate, onEnd, extended, to, noPosition } = props;
  const destinationTime = to === 'start' ? startDate : endDate;
  const { timer } = useCountdownTimer({ endDate: destinationTime, onEnd });
  const containerStyle = getContainerStyle(extended, noPosition);
  const textStyle = getTextStyle(extended, noPosition);
  const { textRef } = useWidgetAdaptiveText({ padding: 4 });

  return (
    <div className={containerStyle}>
      <span ref={textRef} className={textStyle}>
        {timer}
      </span>
    </div>
  );
}

export const TournamentWidgetTimer = observer(TournamentWidgetTimerComponent);
